export default __webpack_public_path__ + "static/media/Mastercard.d7bc0a78.svg";